(function () {
  'use strict';

  if (window.__merchantIframeTitleInit) {
    return;
  }
  window.__merchantIframeTitleInit = true;

  function labelIframe(iframe) {
    if (!iframe.title) {
      iframe.setAttribute('title', 'Google Customer Reviews');
    }
  }

  function checkNode(node) {
    if (!node || node.nodeType !== 1) {
      return;
    }
    if (
      node.tagName === 'IFRAME' &&
      (node.id === 'merchantwidgetiframe' ||
        (node.src || '').indexOf('/shopping/merchantverse/') !== -1)
    ) {
      labelIframe(node);
      return;
    }
    var iframes = node.querySelectorAll
      ? node.querySelectorAll(
          'iframe#merchantwidgetiframe, iframe[src*="/shopping/merchantverse/"]'
        )
      : [];
    for (var i = 0; i < iframes.length; i++) {
      labelIframe(iframes[i]);
    }
  }

  function scanExisting() {
    var byId = document.getElementById('merchantwidgetiframe');
    if (byId) {
      labelIframe(byId);
    }
    var bySrc = document.querySelectorAll(
      'iframe[src*="/shopping/merchantverse/"]'
    );
    for (var i = 0; i < bySrc.length; i++) {
      labelIframe(bySrc[i]);
    }
  }

  scanExisting();

  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var added = mutations[m].addedNodes;
      for (var n = 0; n < added.length; n++) {
        checkNode(added[n]);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
